import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	CardDescription,
} from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { SectionHeader } from '../SectionHeader'
import { useTranslation } from '@/hooks/useTranslation'

export const NextJsSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="nextjs" className="mb-16">
			<SectionHeader id="nextjs">{t('docs.nextjs.title')}</SectionHeader>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle>{t('docs.nextjs.appRouter.title')}</CardTitle>
					<CardDescription>
						{t('docs.nextjs.appRouter.description')}
					</CardDescription>
				</CardHeader>
				<CardContent>
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.nextjs.appRouter.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							app/layout.tsx
						</code>
						{t('docs.nextjs.appRouter.instruction.suffix')}
					</p>
					<CodeBlock
						language="tsx"
						copyLabel={t('docs.nextjs.appRouter.copyLabel')}
						copyMessage={t('docs.nextjs.appRouter.copyMessage')}
						code={`import Script from 'next/script'

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <html lang="en">
      <body>
        {children}
        <Script
          id="feedbask-widget-script"
          strategy="lazyOnload"
          src="https://cdn.feedbask.com/widget.js"
          data-client-key="YOUR_WIDGET_ID"
          data-language="en"
        />
      </body>
    </html>
  )
}`}
					/>
				</CardContent>
			</Card>

			<Card className="mt-6 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle>{t('docs.nextjs.pagesRouter.title')}</CardTitle>
					<CardDescription>
						{t('docs.nextjs.pagesRouter.description')}
					</CardDescription>
				</CardHeader>
				<CardContent>
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.nextjs.pagesRouter.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							pages/_document.tsx
						</code>{' '}
						{t('docs.nextjs.pagesRouter.instruction.suffix')}
					</p>
					<CodeBlock
						language="tsx"
						copyLabel={t('docs.nextjs.pagesRouter.copyLabel')}
						copyMessage={t('docs.nextjs.pagesRouter.copyMessage')}
						code={`import { Html, Head, Main, NextScript } from 'next/document'
import Script from 'next/script'

export default function Document() {
  return (
    <Html lang="en">
      <Head />
      <body>
        <Main />
        <NextScript />
        <Script
          id="feedbask-widget-script"
          strategy="lazyOnload"
          src="https://cdn.feedbask.com/widget.js"
          data-client-key="YOUR_WIDGET_ID"
          data-language="en"
        />
      </body>
    </Html>
  )
}`}
					/>
				</CardContent>
			</Card>
		</section>
	)
}